import { defineStore, createPinia } from "pinia";

export const pinia = createPinia();

export const appStore = defineStore("appStore", {
  state: () => {
    return {
      appEnvironment: "",
      applicationState: "" as any,
      message: [],
    };
  },
  actions: {
    setAppEnvironment(appEnv: any) {
      // console.log("store.ts: setAppEnvironment(", appEnv, ");");
      this.appEnvironment = appEnv;
    },
    setApplicationState(applicationState: any) {
      // console.log("store.ts: setApplicationState(", applicationState, ");");
      this.applicationState = applicationState;
    },
    setMessage(message: any) {
      // console.log("store.ts: setMessage(", message, ");");
      this.message = message;
    },
  },
});
